import { GlobalStyles } from '@mui/material';
import { slickThemeStyle } from './slick-theme.style';
import { slickStyle } from './slick.style';
export const ReactSlickStyle = () => <GlobalStyles styles={{
  ...slickStyle,
  ...slickThemeStyle
}} data-sentry-element="GlobalStyles" data-sentry-component="ReactSlickStyle" data-sentry-source-file="ReactSlickStyle.tsx" />;